export const parseTab = (activeTab) => {
  const [idStr = null, type = null] = (activeTab || '').split('-');
  const id = idStr && !isNaN(Number(idStr)) ? Number(idStr) : idStr;
  return { id, type };
};